import React from 'react';
import './style.scss';
import ControlPanel from '../../components/ControlPanel/ControlPanel';
import RequestsPanel from '../../components/RequestsPanel/RequestsPanel';


function RequestsPage({ chatToken, hotelId, socket, disabledPages, hotelData }) {
  return (
    <div className="dashboard-body">
      <ControlPanel page="requests" disabledPages={disabledPages}></ControlPanel>
      <RequestsPanel chatToken={chatToken} hotelId={hotelId} socket={socket} hotelData={hotelData}></RequestsPanel>
    </div>
  );
}

export default RequestsPage;
